import Button from "components/Button";
import Input from "components/Input";
import MaskedInput from "components/MaskedInput";
import { IUpdateUsersProps } from "interfaces/User";
import { IFormError } from "interfaces/ExpressError";
import { isEmailValid } from "utils/isEmailValid";
import { DataForm, DataInput, DocumentContainer } from "../../styles";

type ProfileTabProps = {
  onUpdateSubmit: (event: React.SyntheticEvent) => void;
  addError: (field: string, message: string) => void;
  removeError: (field: string) => void;
  parsed: boolean;
  editUser: IUpdateUsersProps;
  setNewName: React.Dispatch<React.SetStateAction<string>>;
  setNewEmail: React.Dispatch<React.SetStateAction<string>>;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setNewCpf: React.Dispatch<React.SetStateAction<string>>;
  setNewRg: React.Dispatch<React.SetStateAction<string>>;
  errors: IFormError;
};

export default function ProfileTab({
  onUpdateSubmit,
  parsed,
  editUser,
  setNewName,
  setNewCpf,
  setNewRg,
  addError,
  setEmail,
  setNewEmail,
  removeError,
  errors,
}: ProfileTabProps) {
  const cpfMask = "999.999.999-99";
  const rgMask = "99.999.999-9";

  function validateRG(event: React.ChangeEvent<HTMLInputElement>) {
    const rg = event.target.value.replace("_", "");
    if (rg.length < 12) {
      addError("rg", "RG inválido");
      return;
    }

    removeError("rg");
  }

  function validateCPF(event: React.ChangeEvent<HTMLInputElement>) {
    const cpf = event.target.value.replace("_", "");
    if (cpf.length < 14) {
      addError("cpf", "CPF inválido");
      return;
    }

    removeError("cpf");
  }

  function validateEmail(event: React.ChangeEvent<HTMLInputElement>) {
    const email = event.target.value;

    if (!isEmailValid(email)) {
      addError("email", "E-mail inválido");
      return;
    }

    removeError("email");
  }
console.log({editUser})
  return (
    <DataForm
      onSubmit={(event: React.SyntheticEvent) => onUpdateSubmit(event)}
    >
      {parsed && (
        <div>
          <DataInput
            type="text"
            id="name"
            name="name"
            label="Nome completo"
            defaultValue={!parsed ? "--" : editUser.name}
            required={false}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNewName(event.target.value);
            }}
          />
          <DocumentContainer>
            <MaskedInput
              type="text"
              id="CPF"
              name="CPF"
              label="CPF"
              onBlur={validateCPF}
              defaultValue={editUser.cpf}
              required={false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNewCpf(event.target.value);
              }}
              error={errors.cpf}
              mask={cpfMask}
            />
            <MaskedInput
              type="text"
              id="RG"
              onBlur={validateRG}
              name="RG"
              label="RG"
              defaultValue={editUser.rg}
              required={false}
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                setNewRg(event.target.value);
              }}
              error={errors.rg}
              mask={rgMask}
            />
          </DocumentContainer>
          <DataInput
            type="email"
            id="E-mail"
            name="E-mail"
            label="E-mail"
            onBlur={validateEmail}
            defaultValue={editUser.email}
            required={false}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setEmail(event.target.value);
              setNewEmail(event.target.value);
            }}
            error={errors.email || errors.emailExists}
          />
          <Button
            title="Salvar"
            type="submit"
            disabled={Object.keys(errors).length > 0}
          />
        </div>
      )}
    </DataForm>
  );
}
